import { Component, Input, OnInit } from '@angular/core';

type Illustrations = 'no-data.svg' | 'store-search.svg' | 'empty-inventory.svg' | 'notify.svg' | 'add.svg' | 'moved.svg' | 'denied.svg';

@Component({
  selector: 'app-ilustration-with-message',
  templateUrl: './ilustration-with-message.component.html',
  styleUrls: ['./ilustration-with-message.component.scss']
})
export class IlustrationWithMessageComponent implements OnInit {

  constructor() { }

  @Input() illustrationName: Illustrations
  @Input() text: string = ''
  @Input() severity: string = 'normal'
  @Input() showMsgOnTop: boolean = false
  @Input() height: string = '230'

  ngOnInit(): void {
  }

}
